import { render, staticRenderFns } from "./good_cbdw_list.vue?vue&type=template&id=4de25378&scoped=true&"
import script from "./good_cbdw_list.vue?vue&type=script&lang=js&"
export * from "./good_cbdw_list.vue?vue&type=script&lang=js&"
import style0 from "./good_cbdw_list.vue?vue&type=style&index=0&id=4de25378&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de25378",
  null
  
)

export default component.exports